export const profile = {
  title: 'Profile',
  lead: 'Your name, language and privacy settings.',
  pendingBadge: '{{count}} pending consent request',
  nav: {
    label: 'Profile menu',
    profile: 'Profile',
    consents: 'Consents',
    preferences: 'Preferences',
    subscription: 'Subscription',
  },
  preferredLanguage: 'Preferred language',
  preferredLanguageOptional: 'Preferred language (optional)',
  preferredLanguageUnset: 'Not set',
  timezoneUnset: 'Deployment default',
  saved: 'Saved.',
  save: 'Save',
  privateFieldsHint:
    'These four are private — only you can see or change them, whoever else can see the rest of your record.',
  details: {
    title: 'Details',
    rolesTitle: 'Roles',
  },
  regionAndTimezone: {
    title: 'Region & timezone',
  },
  fields: {
    name: 'Name',
    email: 'E-mail',
    nickname: 'Nickname',
    region: 'Region',
    regionUnset: 'Not set',
    regionHint: 'The country your statistics/reports are localized for.',
    timezone: 'Statistics timezone',
    timezoneHint: 'The calendar your statistics days are cut on.',
    gender: 'Gender',
    birthdate: 'Birthdate',
    height: 'Height (cm)',
    weight: 'Weight (kg)',
  },
} as const;
